import { colors } from '../../../../../../../../../colorVars';
import { Body3 } from '../../../../../../../../../components/atomic/text/Text';
export function symbolDoesNotExistBuilder({parsedStatusObj}) {
  return (
    <td>
      <Body3 fontWeight={500} color={colors.lightGrey}>
        Symbol does not exist:
        {parsedStatusObj.nonExistentSymbol
          ? parsedStatusObj.nonExistentSymbol
          : 'N/A'}
        .
      </Body3>
    </td>
  );
}
